import React from 'react';
import type { PermissionsTab } from './types';

interface PermissionsTabsProps {
  active: PermissionsTab;
  onChange: (tab: PermissionsTab) => void;
}

const TABS: Array<{ id: PermissionsTab; label: string }> = [
  { id: 'state', label: 'State' },
  { id: 'policy', label: 'Policy' },
  { id: 'apply', label: 'Apply' },
  { id: 'drift', label: 'Drift' }
];

/**
 * Four-tab navigation across the permissions surfaces, per the design.
 * Single source of truth for which tab is in focus.
 */
export const PermissionsTabs: React.FC<PermissionsTabsProps> = ({ active, onChange }) => {
  return (
    <nav className="permissions-tabs" role="tablist" aria-label="Permissions surfaces">
      {TABS.map((tab) => {
        const isActive = tab.id === active;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            id={`permissions-tab-${tab.id}`}
            aria-selected={isActive}
            aria-controls={`permissions-panel-${tab.id}`}
            className={`permissions-tab${isActive ? ' is-active' : ''}`}
            onClick={() => onChange(tab.id)}
          >
            {tab.label}
          </button>
        );
      })}
    </nav>
  );
};

export default PermissionsTabs;
